import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的任务提示ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  app_type: [
    {required: true, message: '请选择上架APP', trigger: 'change'},
  ],
  title: [
    {...makeRule('请输入提示名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  projectid: [
    {...makeRule('请选择项目', 'integer')},
  ],
  templateid: [
    {validator: (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请至少选择一个分步模板'))
      } else {
        callback()
      }
    }},
  ],
  notice_type: [
    {...makeRule('请选择提示类型', 'integer')},
  ]
}



// WEBPACK FOOTER //
// ./src/views/task-notice/task-notice.rules.js